/* eslint-disable complexity */
import { graphic as graphicRegister } from 'echarts/core';

export function install(graphic: typeof graphicRegister) {
  // 例如 为echarts扩展图形echarts.graphic.extendShape
  const CurveLine = graphic.extendShape({
    type: 'curveLine',
    shape: {
      sx: 0,
      sy: 0,
      ex: 0,
      ey: 0,
      clockwise: true,
      showArrow: true
    },

    buildPath(path, shape) {
      const k = 0.5522848;
      let cp1 = [0, 0];
      let cp2 = [0, 0];
      let angle = 0;
      let { sx, sy, ex, ey } = shape;
      const { clockwise = true, showArrow = true } = shape;
      const arrowLength = 8;
      const originalE = [ex, ey];
      // 终点在起点右上方
      const rtt = ex > sx && ey <= sy;
      // 终点在起点左下方
      const ltb = ex < sx && ey >= sy;
      // 终点在起点右下方
      const rtb = ex >= sx && ey > sy;
      // 终点在起点左上方
      const ltt = ex <= sx && ey < sy;
      if (!clockwise) {
        [sx, sy, ex, ey] = [ex, ey, sx, sy];
      }
      // 根据方向计算控制点cp1、cp2
      const ox = k * (ex - sx);
      const oy = k * (ey - sy);
      if (rtt || ltb) {
        cp1 = [sx, sy + oy];
        cp2 = [ex - ox, ey];
      }
      if (rtb || ltt) {
        cp1 = [sx + ox, sy];
        cp2 = [ex, ey - oy];
      }
      // 根据方向与顺逆时针定义箭头方向
      if ((clockwise && rtt) || (!clockwise && rtt)) {
        angle = 0;
      }
      if ((!clockwise && rtt) || (clockwise && ltt)) {
        angle = -90;
      }
      if ((!clockwise && ltt) || (clockwise && ltb)) {
        angle = -180;
      }
      if ((clockwise && rtb) || (!clockwise && ltb)) {
        angle = -270;
      }
      if ((sx === ex || sy === ey) && !clockwise) {
        angle += 90;
      }
      angle = (angle * Math.PI) / 180;
      // 绘制贝塞尔曲线（椭圆的1/4）
      const tox = originalE[0];
      const toy = originalE[1];
      path.moveTo(sx, sy);
      path.bezierCurveTo(cp1[0], cp1[1], cp2[0], cp2[1], ex, ey);

      // 绘制箭头
      if (showArrow) {
        path.moveTo(tox, toy);
        path.lineTo(
          tox - arrowLength * Math.cos(angle - Math.PI / 5),
          toy - arrowLength * Math.sin(angle - Math.PI / 5)
        );
        path.moveTo(tox, toy);
        path.lineTo(
          tox - arrowLength * Math.cos(angle + Math.PI / 5),
          toy - arrowLength * Math.sin(angle + Math.PI / 5)
        );
      }
    }
  });

  graphic.registerShape('curveLine', CurveLine);
}
